// extracted by mini-css-extract-plugin
export default {"header":"header_header__hHQZG","tabs":"header_tabs__G4rxs","tabList":"header_tabList__QysTT","active":"header_active__6dTvc"};